<!--
 * @Author: ruinan_yu ruinan_yu@kingdee.com
 * @Date: 2022-09-21 09:55:26
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-09-21 09:42:43
 * @FilePath: \code\src\components\Gantt\WBS\SummaryHeader\SummaryHeader.vue
 * @Description: 统计区左侧WBS表头
-->
<template>
  <div
    @scroll.passive="scrollEvent($event)"
    class="summary-normal"
    :class="{
      'gantt-outbox-border': (!$store.state.viewSchem.noGanttOutBoxBorder),
    }"
  >
    <div
      v-for="(item, index) in summaryHeader"
      :key="index"
      class="summary-header"
    >
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SummaryHeader",
  props: {
    summaryHeader: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 滚动联动对象
    reactVueComponent: {
      type: Object,
      default: null,
    },
    reactVueIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    scrollEvent(el) {
      const _self = this;
      if (_self.$store.state.showMode == "both") {
        const scrollTop = _self.$el.scrollTop;
        const _reactVueComponent = this.reactVueComponent;
        let targetEl;

        if (_reactVueComponent != null && _reactVueComponent.$el != null) {
          targetEl = _reactVueComponent.$el;
          targetEl.scrollTop = scrollTop;
        } else {
          // console.log("无绑定联动组件值·C");
          const targetEl =
            _self.$el.parentNode.parentNode.parentNode.parentNode.getElementsByClassName(
              "content-form",
            )[_self.reactVueIndex];
          targetEl.scrollTop = scrollTop;
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.summary-normal{
  position: relative;
  overflow: auto;
  height: 100%;
  white-space: pre;
  &.gantt-outbox-border{
    .summary-header{
      border-left: 1px solid @cBorder;
      border-left: 1px solid var(--border-color, @cBorder);
    }
  }
  .summary-header {
    padding-left: 20px;
    line-height: @summaryCellHeight;
    height: @summaryCellHeight;
    box-sizing: border-box;
    /* border-left: 1px solid @cBorder;
    border-left: 1px solid var(--border-color, @cBorder); */
    border-bottom: 1px solid @cBorderX;
    border-bottom: 1px solid var(--borderX-color, @cBorderX);
    &:last-of-type{
      border-bottom: none;
    }
  }

}
</style>
